// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b70e7260","455":"71e8a817"}[chunkId] + ".chunk.js";
};